import { ICustomerRestriction } from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/types';

export const crmRestrictionDTO = ({ id, mobile, payment_type, customer, comment, disabled_by, disabled_at }: ICustomerRestriction) => ({
  id,
  userId: String(customer.id),
  userPhone: String(mobile),
  paymentType: payment_type,
  comment: comment ? String(comment) : '',
  disabledBy: disabled_by.id ? `${disabled_by.first_name} ${disabled_by.last_name}` : '',
  disabledAt: disabled_at,
});

export const crmRestrictionsDTO = (data: ICustomerRestriction[]) => data.map(crmRestrictionDTO);
